import React, {Component} from 'react';
import PropTypes from "prop-types";
import { withFormik, Form, Field } from 'formik';
import {SlideDown} from 'react-slidedown'
import 'react-slidedown/lib/slidedown.css'
import Yup from 'yup';



class renderForm3 extends Component {

    //Actions
    receiveNextFormNumber = () => {
        this.props.receiveNextFormNumber(2);
    };

    //Renders
    renderWorkingHours = () => {

            return (
                <div className="row form-group">
                 <div className={
                        this.props.touched.workingHours ?
                            (this.props.errors.workingHours
                                ? "has-error form-group"
                                : "has-success form-group")
                            : "form-group"
                    }>
                    <div className="col-sm-4">
                        <p className="text-right-md">
                            <label>
                            During preparation, what best describes the number of hours you will work per week?
                            </label>
                        </p>
                    </div>
                    
                    <div className="col-sm-4">
                        <div className="form-group">
    
                            <Field
                                type="number"
                                name='workingHours'
                                className="form-control"
                                disabled={!!this.props.isReviewForm}
                            />
                            
                            
                        </div>
                    </div>
                </div>
                </div>
            
            )
        
    };
    
    renderSchoolHours = () => {
        
            return (
                <div className="row form-group">
                <div className={
                        this.props.touched.schoolHours ?
                            (this.props.errors.schoolHours
                                ? "has-error form-group"
                                : "has-success form-group")
                            : "form-group"
                    }>
                    <div className="col-sm-4">
                        <p className="text-right-md">
                            <label>
                            During preparation, what best describes the number of hours you will study for school per week?


                            </label>
                        </p>
                    </div>
                    
                    <div className="col-sm-4">
                        <div className="form-group">
    
                            <Field
                                type="number"
                                name='schoolHours'
                                className="form-control"
                                disabled={!!this.props.isReviewForm}
                            />
                        </div>
                    </div>
                </div>
                </div>
            
            )
    };
    
    renderActivityHours = () => {
        
            return (
                <div className="row form-group">
                <div className={
                        this.props.touched.activityHours ?
                            (this.props.errors.activityHours
                                ? "has-error form-group"
                                : "has-success form-group")
                            : "form-group"
                    }>
                    <div className="col-sm-4">
                        <p className="text-right-md">
                            <label>
                            During preparation, what best describes the number of hours you will spend on extracurricular activities per week?


                            </label>
                        </p>
                    </div>
                    
                    <div className="col-sm-4">
                        <div className="form-group">
    
                            <Field
                                type="number"
                                name='activityHours'
                                className="form-control"
                                disabled={!!this.props.isReviewForm}
                                onBlur={e => this.props.collapseForm(1)}
                            />
                        </div>
                    </div>
                </div>
                </div>
            
            )
    };
    
    
    
    //Renders
    renderLiving = () => {

            return (
                <div className="row form-group">
                <div className={
                        this.props.touched.living ?
                            (this.props.errors.living
                                ? "has-error form-group"
                                : "has-success form-group")
                            : "form-group"
                    }>
                    <div className="col-sm-4">
                        <p className="text-right-md">
                            <label>
                            You Live
                            </label>
                        </p>
                    </div>
                    
                    <div className="col-sm-4">
                        <div className="form-group">
    
                            <Field
                                component="select"
                                name='living'
                                className="form-control"
                                disabled={!!this.props.isReviewForm}
                            >
                            
                
                                <option value="">Choose</option>
                                <option value="Alone">Alone</option>
                                <option value="With roommates">With roommates</option>
                                <option value="With family">With family</option>
                                                                      
                            </Field>
                        </div>
                    </div>
                </div>
                </div>
            
            )
        
    };
    
    renderRoom = () => {

            return (
                <div className="row form-group">
                <div className={
                        this.props.touched.room ?
                            (this.props.errors.room
                                ? "has-error form-group"
                                : "has-success form-group")
                            : "form-group"
                    }>
                    <div className="col-sm-4">
                        <p className="text-right-md">
                            <label>
                            You have a private room or study space at my home


                            </label>
                        </p>
                    </div>
                    
                    <div className="col-sm-4">
                        <div className="form-group">
    
                            <Field
                                component="select"
                                name='room'
                                className="form-control"
                                disabled={!!this.props.isReviewForm}
                            >
                            

                                                                                <option value="">Choose</option>
                                                                                <option value="Yes">Yes</option>
                                                                                <option value="No">No</option>
                                                                           
                                                                      
                            </Field>
                        </div>
                    </div>
                </div>
            </div>
            )
        
    };
    
    renderDependents = () => {

            return (
                <div className="row form-group">
                <div className={
                        this.props.touched.dependents ?
                            (this.props.errors.dependents
                                ? "has-error form-group"
                                : "has-success form-group")
                            : "form-group"
                    }>
                    <div className="col-sm-4">
                        <p className="text-right-md">
                            <label>
                            In some way, you look after how many people? These could include parents, siblings, spouse or children
                            </label>
                        </p>
                    </div>
                    
                    <div className="col-sm-4">
                        <div className="form-group">
    
                            <Field
                                component="select"
                                name='dependents'
                                className="form-control"
                                disabled={!!this.props.isReviewForm}
                            >
                            
                                                                                <option value="">Choose</option>
                                                                                <option value="0">0</option>
                                                                                <option value="1">1</option>
                                                                                <option value="2">2</option>
                                                                                <option value="3">3</option>
                                                                                <option value="4">4</option>
                                                                            
                                                                      
                            </Field>
                        </div>
                    </div>
                </div>
                </div>
            
            )
        
    };
    
    
    renderAdditional = () => {

            return (
                <div className="row form-group">
                    <div className="col-sm-4">
                        <p className="text-right-md">
                            <label>
                            Is there anything you would like to say about your environment that we should be aware of? You would be surprised how many students don’t have ideal study situations.
                            </label>
                        </p>
                    </div>
                    
                    <div className="col-sm-4">
                        <div className="form-group">
    
                            <Field
                                component="textarea"
                                rows={"4"}
                                name='additional'
                                style={{height: 160}}
                                className="form-control"
                                disabled={!!this.props.isReviewForm}
                                onBlur={e => this.props.collapseForm(2)}
                            />
                        </div>
                    </div>
                </div>
            
            )
        
    };
    
    
    renderAdditional2 = () => {

            return (
                <div className="form-group">
                    <div className="col-sm-12">
                        <p className="sm-bottom40">
                            <label>
                            Tell us anything you’d like us to know about you, professionally or personally! What are your interests? Aspirations? Why are you pursuing this profession? What’s unique about you?
                            </label>
                        </p>
                    </div>
                    
                    <div className="col-sm-12">
                        <div className="form-group">
    
                            <Field
                                component="textarea"
                                rows={"4"}
                                style={{height: 200}}
                                name='additional2'
                                className="form-control"
                                disabled={!!this.props.isReviewForm}
                            />
                        </div>
                    </div>
                </div>
            
            )
        
    };

    renderMartialStatus = () => (
        <div className="col-sm-3">
            <div className="form-group">
                <label>Whats your martial status?</label>
                <Field
                    component='select'
                    name='martialStatus'
                    className="form-control"
                    disabled={!!this.props.isReviewForm}>
                    <option value="">
                        Choose
                    </option>
                    <option value="single">Single</option>
                    <option value="married">Married</option>
                    <option value="divorced">Divorced</option>
                    <option value="widowed">Widowed</option>
                    <option value="other">Other</option>
                </Field>
            </div>
        </div>
    );

    renderHasChildren = () => (
        <div className="col-sm-3">
            <div className="form-group">
                <label>Do you have any children?</label>
                <div className="sp-top10">
                    <label className="radioBtn-ladel">
                        <div
                            className={
                                this.props.values.hasChildren !== 'false'
                                    ? "iradio_square unactive radio-relative"
                                    : "iradio_square checked radio-relative"
                            }
                            aria-checked="false"
                            aria-disabled="false"
                        >
                            <Field
                                type="radio"
                                className="ichekRadioBtn iCheck-custom"
                                value="false"
                                name="hasChildren"
                                disabled={!!this.props.isReviewForm}
                            />
                            <ins className="iCheck-helper iCheck-custom"/>
                        </div>
                        No
                    </label>
                    <label className="radioBtn-ladel">
                        <div
                            className={
                                this.props.values.hasChildren === 'false'
                                    ? "iradio_square unactive radio-relative"
                                    : "iradio_square checked radio-relative"
                            }
                        >
                            <Field
                                type="radio"
                                className="ichekRadioBtn iCheck-custom"
                                value="true"
                                name="hasChildren"
                                disabled={!!this.props.isReviewForm}
                            />
                            <ins className="iCheck-helper iCheck-custom" />
                        </div>
                        Yes
                    </label>
                </div>
            </div>
        </div>
    );

    renderHasDisabilities = () => (
        <div className="col-sm-3">
            <div className="form-group">
                <label>Are you diagnosed with any disabilities?</label>
                <div className="sp-top10">
                    <label className="radioBtn-ladel">
                        <div
                            className={
                                this.props.values.hasDisabilities !== 'false'
                                    ? "iradio_square unactive radio-relative"
                                    : "iradio_square checked radio-relative"
                            }
                            aria-checked="false" aria-disabled="false"
                        >
                            <Field
                                type="radio"
                                className="ichekRadioBtn iCheck-custom"
                                value="false"
                                name="hasDisabilities"
                                disabled={!!this.props.isReviewForm}
                            />
                            <ins className="iCheck-helper iCheck-custom"/>
                        </div>
                        No
                    </label>
                    <label className="radioBtn-ladel">
                        <div
                            className={
                                this.props.values.hasDisabilities === 'false'
                                    ? "iradio_square unactive radio-relative"
                                    : "iradio_square checked radio-relative"
                            }>
                            <Field
                                type="radio"
                                className="ichekRadioBtn iCheck-custom"
                                value="true"
                                name="hasDisabilities"
                                disabled={!!this.props.isReviewForm}
                            />
                            <ins className="iCheck-helper iCheck-custom" />
                        </div>
                        Yes
                    </label>
                </div>
            </div>
        </div>
    );

    renderIsEmployed = () => (
        <div className="col-sm-3">
            <div className="form-group">
                <label>Are you currently employed?</label>
                <div className="sp-top10">
                    <label className="radioBtn-ladel">
                        <div
                            className={
                                this.props.values.isEmployed !== 'false'
                                    ? "iradio_square unactive radio-relative"
                                    : "iradio_square checked radio-relative"
                            }
                            aria-checked="false"
                            aria-disabled="false"
                        >
                            <Field
                                ype="radio"
                                className="ichekRadioBtn iCheck-custom"
                                value="false"
                                name="isEmployed"
                                disabled={!!this.props.isReviewForm}
                            />
                            <ins className="iCheck-helper iCheck-custom"/>
                        </div>
                        No
                    </label>
                    <label>
                        <div
                            className={
                                this.props.values.isEmployed === 'false'
                                    ? "iradio_square unactive radio-relative"
                                    : "iradio_square checked radio-relative"
                            }>
                            <Field
                                type="radio"
                                className="ichekRadioBtn iCheck-custom"
                                value="true"
                                name="isEmployed"
                                disabled={!!this.props.isReviewForm}
                            />
                            <ins className="iCheck-helper iCheck-custom" />
                        </div>
                        Yes
                    </label>
                </div>
            </div>
        </div>
    );

    render () {
        const {
            values,
            isSubmitting,
            handleSubmit,
            isReviewForm,
            collapseForm,
            collapsedForms,
            touched,
            errors,
            toggleCollapse
        } = this.props;
        return (
            <Form
                action="#"
                id="submit_form"
                onSubmit={handleSubmit}
            >
                <div className="form-wizard">
                    <div className="form-body">
                        <div className={
                            "tab-content "+ (
                                isReviewForm
                                ? "review"
                                : ""
                            )
                        }>
                            <div
                                className="tab-pane active"
                                id="tab3">
                                
                                
                                <div className={`form-section ${(collapsedForms.indexOf(1) > -1 && !errors.workingHours && !errors.schoolHours && !errors.activityHours) ? 'hiddenFormSectionBody' : ''}`}>
                                <h3 className="form-heading" onClick={e => toggleCollapse(1)}>
                                Commitments
                                
                                {(touched.workingHours && touched.schoolHours && touched.activityHours && !errors.workingHours && !errors.schoolHours && !errors.activityHours) &&
                                    <i className="zmdi zmdi-chevron-down"></i>
                                    
                                }
                                </h3>
                            <div className="form-section-body" style={{height: (collapsedForms.indexOf(1) > -1 && !errors.workingHours && !errors.schoolHours && !errors.activityHours) ? '0px' : 'initial'}}>

                                        <div className="row">
                                            {this.renderWorkingHours()}
                                            {this.renderSchoolHours()}
                                            {this.renderActivityHours()}
                                        </div>
                                    </div>
                                </div>
                                
                                
                                <div className={`form-section ${(collapsedForms.indexOf(2) > -1 && !errors.living && !errors.room && !errors.dependents) ? 'hiddenFormSectionBody' : ''}`}>
                                <h3 className="form-heading" onClick={e => toggleCollapse(1)}>
                                Environment
                                
                                {(touched.living && touched.room && touched.dependents && !errors.living && !errors.room && !errors.dependents) &&
                                    <i className="zmdi zmdi-chevron-down"></i>
                                    
                                }
                                </h3>

                                    <div className="form-section-body">
                                        <div className="row">
                                            {this.renderLiving()}
                                            {this.renderRoom()}
                                            {this.renderDependents()}
                                            {this.renderAdditional()}
                                        </div>
                                    </div>
                                </div>
                                
                                
                                <div className="form-section">
                                    
                                    <div className="form-section-body">
                                        <div className="row">
                                            
                                            {this.renderAdditional2()}
                                        </div>
                                    </div>
                                </div>
                               

                            </div>
                        </div>
                    </div>
                    {
                        !isReviewForm &&
                        <div className="onboarding-form-step form-actions sm-top50">
                            <div className="row">
                                <div className="col-md-12 text-right">
                                    <button
                                        className="btn btn-default btn-lg font-16 button-previous"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            this.props.setPrevStep();
                                        }}
                                    >
                                        <i className="m-icon-swapleft"/>
                                        Back
                                    </button>
                                    <button
                                        className="btn btn-danger button-next btn-lg font-16"
                                        disabled={isSubmitting}
                                        onClick={e => {
                                        this.props.findError();
                                        this.props.handleSubmit(e);
                                    }}
                                    >
                                        Continue <i className="m-icon-swapright m-icon-white"/>
                                    </button>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </Form>
        )
    }
};

const Form3 = withFormik({

    mapPropsToValues({ parentProps,
                         martialStatus,
                         hasChildren,
                         hasDisabilities,
                         isEmployed,
                         workingHours,
                         schoolHours,
                         activityHours,
                         living,
                         room,
                         dependents,
                         additional,
                         additional2
                     })
    {
        return {
            martialStatus: martialStatus || parentProps.profile.personal.martialStatus || '',
            hasChildren: hasChildren || parentProps.profile.personal.hasChildren || 'false',
            hasDisabilities: hasDisabilities || parentProps.profile.personal.hasDisabilities || 'false',
            isEmployed: isEmployed || parentProps.profile.personal.isEmployed || 'false',
            workingHours: workingHours || parentProps.profile.personal.workingHours || 0,
            schoolHours: schoolHours || parentProps.profile.personal.schoolHours || 0,
            activityHours: activityHours || parentProps.profile.personal.activityHours || 0,
            living: living || parentProps.profile.personal.living || '',
            room: room || parentProps.profile.personal.room || '',
            dependents: dependents || parentProps.profile.personal.dependents || '',
            additional: additional || parentProps.profile.personal.additional || '',
            additional2: additional2 || parentProps.profile.personal.additional2 || '',
        };
    },
    
     validationSchema: Yup.object().shape({

        workingHours: Yup.number("Must enter a number").required('required'),
        schoolHours: Yup.number("Must enter a number").required('required'),
        activityHours: Yup.number("Must enter a number").required('required'),
        living: Yup.string().required('required'),
        room: Yup.string().required('required'),
        dependents: Yup.string().required('required')
        

    }),

    handleSubmit(values, {resetForm, setErrors, setSubmitting, props}) {
        setTimeout(() => {
            if (values.email === 'test@test.io') {
                setErrors({ email: 'This email is already token' })
            } else {
                props.onCircumstancesInfoUpdate(
                    {
                        martialStatus: values.martialStatus,
                        hasChildren: values.hasChildren,
                        hasDisabilities: values.hasDisabilities,
                        isEmployed: values.isEmployed,
                        workingHours: values.workingHours,
                        schoolHours: values.schoolHours,
                        activityHours: values.activityHours,
                        living: values.living,
                        room: values.room,
                        dependents: values.dependents,
                        additional: values.additional,
                        additional2: values.additional2
                    }
                );
                // props.receivedValues(values);
                props.receiveNextFormNumber(4);
            }
        }, 200)
    }

})(renderForm3);


Form3.propTypes = {

    receiveNextFormNumber: PropTypes.func.isRequired,

    infoCircumstances: PropTypes.shape({
        martialStatus: PropTypes.string,
        hasChildren: PropTypes.string,
        hasDisabilities: PropTypes.string,
        isEmployed: PropTypes.string,
        workingHours: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
    }),
};


export default Form3;



// WEBPACK FOOTER //
// ./src/components/onBoarding/Form3.js